import { render } from "./FileTemplate.vue?vue&type=template&id=b9dbea1c"
import script from "./FileTemplate.vue?vue&type=script&lang=js"
export * from "./FileTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__